import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import React, { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getGroupsForUserRequest, updateUserRequest } from "../../../../../actions";
import { IRootReducer, UserInfoAdmin } from "../../../../../reducers";
import { CleanPhoneNumberUtil } from "../../../../../utils/string-utils";
import { useAuthContext } from "../../../../../core/auth-context";
import { useAgency } from "../../../../../hooks/agencies";

interface ChangeUserStatusProps {
  props: {
    rowCountSelected: number;
    userSelection: UserInfoAdmin;
  };
}

const ChangeUserStatus: FC<ChangeUserStatusProps> = ({ props }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({} as UserInfoAdmin);

  const { authState } = useAuthContext();
  const userAgency = useAgency(userDetails.agency);
  const userAgencyAbbr = userAgency?.abbreviation || userDetails.agency;

  const userGroupsStore = useSelector(
    (state: IRootReducer) => state.adminReducer.groupsForUser
  );

  const handleOpen = () => {
    setOpen(true);
    dispatch(getGroupsForUserRequest(props.userSelection?.email));
    setUserDetails(props.userSelection);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleStatusChangeAndClose = () => {
    let cleanNumber = "";
    if (userDetails.phoneNumber) {
      cleanNumber = CleanPhoneNumberUtil(userDetails.phoneNumber);
    }

    dispatch(
      updateUserRequest(
        authState.email?.toLowerCase() ?? "",
        userDetails.cognitoUsername,
        userDetails.email,
        userDetails.firstName,
        userDetails.lastName,
        cleanNumber,
        userDetails.agency || "",
        userDetails.jogId || "",
        userDetails.enabled === "Y" ? "N" : "Y", // If enabled, disabled. If disabled, enable
        userGroupsStore,
        [],
        []
      )
    );

    setOpen(false);
  };

  const isBtnEnabled = () => {
    return props.rowCountSelected === 1;
  }

  function isDisableAction() {
    return isBtnEnabled() && props.userSelection?.enabled === "Y";
  }

  return (
    <>
      <Tooltip
        title={
          (isDisableAction() ? "Disable" : "Re-enable") +
          " access for a single user from the VCC"
        }
      >
        {/* Wrapped in "Box" to avoid MUI console error for wrapping disabled element in Tooltip */}
        <Box>
          <Button
            style={{ minWidth: "150px", color: isBtnEnabled() ? "white" : "black" }}
            variant="contained"
            color={isBtnEnabled() ? "primary" : "inherit"}
            onClick={handleOpen}
            disabled={!isBtnEnabled()}
          >
            {!isBtnEnabled() ? "Disable or Re-Enable" : isDisableAction() ? "Disable User" : "Re-Enable User"}
          </Button>
        </Box>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleCancel}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {isDisableAction() ? "Disable User" : "Re-Enable User"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to{" "}
            {isDisableAction() ? "disable" : "re-enable"} VCC access to:
          </DialogContentText>
          <DialogContentText>
            Name: {userDetails.firstName + " " + userDetails.lastName} <br />
            Email: {userDetails.email} <br />
            Agency: {userAgencyAbbr} <br />
          </DialogContentText>
          <DialogActions>
            <Button onClick={handleCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={handleStatusChangeAndClose} color="primary">
              {isDisableAction() ? "Disable" : "Re-enable"}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ChangeUserStatus;
